export default __webpack_public_path__ + "static/media/thankyoukeyvis_tickets_dt@2x.abb1e5ce.png";